import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { X } from 'lucide-react';
import { FALL_SPECIAL, fallPromoCopy } from '../data/fallSpecial';
import { FallOfferBlock } from './FallOfferBlock';

const STORAGE_KEY = `promo_${FALL_SPECIAL.key}_modal_seen`;

const PromoModal = () => {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const copy = fallPromoCopy();

  useEffect(() => {
    let seen = false;
    try { seen = localStorage.getItem(STORAGE_KEY) === '1'; } catch (e) { /* ignore */ }
    if (seen) return undefined;
    const t = setTimeout(() => setOpen(true), 2500);
    return () => clearTimeout(t);
  }, []);

  const close = () => {
    setOpen(false);
    try { localStorage.setItem(STORAGE_KEY, '1'); } catch (e) { /* ignore */ }
  };

  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-[60] bg-black/70 flex items-center justify-center p-3 sm:p-4 animate-in fade-in duration-200"
      onClick={close}
      data-testid="promo-modal"
    >
      <div
        className="relative bg-white rounded-2xl shadow-2xl max-w-md w-full overflow-hidden max-h-[92vh] flex flex-col"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          onClick={close}
          aria-label="Close"
          className="absolute top-3 right-3 z-10 w-9 h-9 rounded-full bg-white/90 hover:bg-white text-slate-700 flex items-center justify-center shadow"
          data-testid="promo-modal-close"
        >
          <X className="w-5 h-5" />
        </button>

        <div className="overflow-y-auto">
          <button
            onClick={() => { close(); navigate(FALL_SPECIAL.path); }}
            className="block w-full"
            data-testid="promo-modal-flyer"
          >
            <picture>
              <source srcSet={FALL_SPECIAL.flyerWebp} type="image/webp" />
              <img src={FALL_SPECIAL.flyer} alt={`${copy.title} — ${copy.tagline}. A Quality Handyman LLC`} className="w-full h-auto max-h-[46vh] object-cover object-top" />
            </picture>
          </button>
          <div className={`p-4 bg-gradient-to-b ${copy.theme.light} to-white`}>
            <p className="text-[11px] font-bold uppercase tracking-widest text-orange-700 mb-1">{copy.badgeText}</p>
            <FallOfferBlock source="fall_special_modal" compact onNavigate={close} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default PromoModal;
